import React from "react";

export default (props: React.SVGAttributes<SVGElement>) =>
<svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000" {...props}><path d="M2 4.6h11V7H2zM2 10.8h8v2.4H2zM2 17h5v2.4H2zM17.4 4v11.1h-3.2l4.3 5.4 4.3-5.4h-3.2V4z"/></svg>;
